import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../../environments/environment';
import { LogService } from 'ngx-log-service';
import { Observable, ReplaySubject, throwError, of } from "rxjs";
import { ResponseData } from "../models/responsedata";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class ConfigService {
    constructor(private logService: LogService, private http: HttpClient) {
        this.logService.namespace = 'ConfigService';
    }
    
    private configLookupEndpoint = '/api/configurations/maintenance';

    public configuration$: ReplaySubject<Map<string, boolean>> = new ReplaySubject<Map<string, boolean>>(1);
    private cachedConfigData : Map<string, boolean> = null;
    private _configRetrieved = false;

    private getConfigData(): Observable<Map<string, boolean>> { 
        var configLookupUrl = window.location.origin + this.configLookupEndpoint;
        return this.http.get<Map<string, boolean>>(configLookupUrl)
			.pipe(map(responseObject => responseObject,	catchError(err => this.returnErrorEvent(err))));
    }

    public getConfig(): Observable<Map<string, boolean>> {
        if(!this.cachedConfigData) {
            return this.getConfigData()
                .pipe(catchError((err, caught) => {
                    this._configRetrieved = false;
                    this.handleErrorLog(err);
                    return throwError(err);
                }));
        } else {
            this.configuration$.next(this.cachedConfigData);
            return of(this.cachedConfigData);
        }
    }

    private returnErrorEvent(error: HttpErrorResponse | any): Observable<never> {
		this.handleErrorLog(error);
		return throwError(error);
	}

    private handleErrorLog(error: HttpErrorResponse | any): void {
		const errMsg: string = error.message ? error.message : error.toString();
		this.logService.fatal('Config retrieval has failed', { data: error, message: errMsg });
	}
}